import { render, staticRenderFns } from "./EcobalyseIngredients.vue?vue&type=template&id=af6de68a&scoped=true&"
import script from "./EcobalyseIngredients.vue?vue&type=script&lang=js&"
export * from "./EcobalyseIngredients.vue?vue&type=script&lang=js&"
import style0 from "./EcobalyseIngredients.vue?vue&type=style&index=0&id=af6de68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6de68a",
  null
  
)

export default component.exports